import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { ProviderConfigList } from 'config/providers';
import { YardiTheme } from 'config/themes';
import { trialPartnerAsyncEligible } from 'config/sharedFunctions';

// YardiEmbed is the experimental future state for Yardi microsite (contrast to YardiIFramed)
export const YardiEmbed: MultiProviderConfig = {
  name: 'YardiEmbed',
  displayName: 'Yardi',
  micrositeCode: 'YardiEmbed',
  source: 'YardiEmbed',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: '',
  title: 'Compare and shop for internet & TV with Yardi',
  fallbackPhoneNumber: '844-718-8906',
  fallbackLeadModePhoneNumber: '844-718-8906',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: YardiTheme,
  updaterCrossSellActive: false,
  needsDcSession: false,
  noOffersRetry: 2,
  allowCommercialAddress: true,
  providers: ProviderConfigList,
  getCheckoutType: trialPartnerAsyncEligible,
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    qa: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    production: 'https://partner-cart.updater.com/guest/tvi/buy',
  },
  iFrameConfig: {
    hideHeaderAndFooter: true,
    trustedHosts: {
      production: [
        '*.securecafe.com',
        '*.securecafeapplicant.com',
        '*.securecafenet.com',
        '*.securecaferesident.com',
        '*.rsshield.com',
        '*.rentcafe.com',
      ],
    },
  },
};
